import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import enCore from "@/locales/en/core.json";
import frCore from "@/locales/fr/core.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { core: enCore },
      fr: { core: frCore },
    },
    fallbackLng: "fr",
    supportedLngs: ["fr", "en"],
    defaultNS: "core",
    ns: ["core"],
    interpolation: { escapeValue: false },
    detection: { order: ["querystring", "localStorage", "navigator"], caches: ["localStorage"] },
  });

export default i18n;
